import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  video: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      border: 0,
      display: "block",
      width: "100vw",
      height: "56.25vw",
      marginBottom: theme.spacing(3)
    }
  }
}));

const videoSrc =
  "https://www.youtube.com/embed/SszXohFrcYE?playlist=SszXohFrcYE&modestbranding=1&showinfo=0&iv_load_policy=3&disablekb=1&fs=0&cc_load_policy=0";

const HeroVideo = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery(useTheme().breakpoints.down("xs"));

  return (
    <iframe
      src={isMobile ? videoSrc : ""}
      title="Get Kulpa"
      className={classes.video}
      allow="autoplay; encrypted-media"
      allowFullScreen
    />
  );
};

export default HeroVideo;
